import React from 'react'
import {Flex} from '@salesforce/retail-react-app/app/components/shared/ui'
import DrawerCategoryItem from './drawer-category-item'
import PropTypes from 'prop-types'
import DrawerHeaderLinks from './drawer-header-links'
import useCorporateLayout from '../../hooks/use-corporate-layout'

const DrawerMenuFirstLevel = ({categoriesData, setSelectedCategory}) => {
    const {showCorporateLayout} = useCorporateLayout()
    const handleCategorySelection = (categoryUid) => {
        setSelectedCategory(categoryUid)
    }
    return (
        <Flex flexDir="column" alignItems="flex-start">
            {!showCorporateLayout &&
                categoriesData &&
                categoriesData?.primarycategories?.map((primarycategory) => {
                    return (
                        <Flex
                            w="100%"
                            key={primarycategory.uid}
                            onClick={() => handleCategorySelection(primarycategory?.uid)}
                        >
                            <DrawerCategoryItem primaryCategory={primarycategory} />
                        </Flex>
                    )
                })}
            <DrawerHeaderLinks categoriesData={categoriesData} />
        </Flex>
    )
}

DrawerMenuFirstLevel.propTypes = {
    categoriesData: PropTypes.object,
    setSelectedCategory: PropTypes.func,
}

export default DrawerMenuFirstLevel
